import * as React from "react";
import {Dialog} from "../../core/Dialog";
import {ConfirmationDialogOptions} from "./ConfirmationDialog";

export class ConfirmationDialogInstance extends React.Component<ConfirmationDialogInstanceProps, ConfirmationDialogInstanceState> {
    static defaultProps: Partial<ConfirmationDialogInstanceProps> = {
        EnableCancelButton:true,
        ApplyText:'Yes',
        CancelText:'No'
    };
    public OnDispose:()=>void;
    public SendResult:(result)=>void;

    constructor(props: ConfirmationDialogInstanceProps) {
        super(props);
        this.state = {
            IsOpen:true,
            IsBusy:false
        };
    }

    public render() {
        return (
            <Dialog EnableApply={true} CancelTitle={this.props.CancelText}  EnableCancel={this.props.EnableCancelButton} OnClose={()=>this.SendResult(false)} AfterOnClose={()=>this.OnDispose()} OnApply={()=>this.Apply()} ApplyTitle={this.props.ApplyText} ApplyIcon={this.props.Options.Icon} Title={this.props.Options.Title} IsOpen={this.state.IsOpen} IsBusy={this.state.IsBusy}>
                {this.props.Options.Content}
            </Dialog>
        )
    }

    private async Apply() {
        if(this.props.Options.OnApply!=null)
        {
            this.setState({IsBusy:true});
            let result=await this.props.Options.OnApply();
            this.setState({IsBusy:false});
            if(result)
            {
                this.setState({IsOpen:false});
            }
        }else {
            this.SendResult(true);
            this.setState({IsOpen: false});
        }

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ConfirmationDialogInstanceProps {
    Options:ConfirmationDialogOptions;
    EnableCancelButton:boolean;
    ApplyText:string;
    CancelText:string;
}

interface ConfirmationDialogInstanceState {
    IsOpen:boolean;
    IsBusy:boolean;
}

//#endregion "My Region"